<section class="working" id="screens">
  <div class="container">
    <div class="working-layout">
      <!-- Left Side: Section Header and Screenshot Names -->
      <div class="workflow-content">
        <div class="working-header mb-4">
          <div class="section-header mb-3">
            <h2 class="workflow-title">{{ getTabTitle() }}</h2>
            <div class="title-accent"></div>
          </div>
        </div>

        <div class="workflow-steps">
          <div
            *ngFor="let screenshot of currentCategoryScreenshots; let i = index"
            class="workflow-step"
            [class.active]="isActive(i)"
            (click)="selectImage(i)"
          >
            <div class="step-content">
              <span class="step-number" [class.active]="isActive(i)">0{{ i + 1 }}</span>
              <h4 class="step-title">{{ screenshot.name }}</h4>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Side: Tabs and Carousel Column -->
      <div class="workflow-carousel-col">
        <div class="carousel-unified">
          <div class="app-tabs">
            <div
              class="tab-item"
              *ngFor="let tab of getTabData()"
              [class.active]="selectedTab === tab.key"
              (click)="selectTab(tab.key)"
            >
              <ng-container [ngSwitch]="tab.icon">
                <svg *ngSwitchCase="'monitor'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="4" width="18" height="12" rx="1.5" stroke="currentColor" stroke-width="1.8" />
                  <line x1="8" y1="20" x2="16" y2="20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                  <line x1="12" y1="16" x2="12" y2="20" stroke="currentColor" stroke-width="1.8" />
                </svg>
                <svg *ngSwitchCase="'phone'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="7" y="3" width="10" height="18" rx="2" stroke="currentColor" stroke-width="1.8" />
                  <line x1="11" y1="18" x2="13" y2="18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                </svg>
                <svg *ngSwitchCase="'bike'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="5.5" cy="17.5" r="3.5" stroke="currentColor" stroke-width="1.8" />
                  <circle cx="18.5" cy="17.5" r="3.5" stroke="currentColor" stroke-width="1.8" />
                  <path
                    d="M5.5 17.5 10 8h4l4.5 9.5M10 8l3 5H6.5"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg *ngSwitchCase="'store'" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 9 5 4h14l1 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M4 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
                  <path d="M5 9v10h14V9" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                  <path d="M9 19v-5h6v5" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
                </svg>
              </ng-container>
              <span>{{ tab.name }}</span>
            </div>
          </div>

          <div class="carousel-wrapper" (click)="openModal()">
            <div class="carousel-bg" [style.backgroundImage]="'url(' + modalImageSrc + ')'"></div>
            <div class="carousel-track" [class]="'slide-' + currentImageIndex">
              <img
                *ngFor="let image of currentImages; let i = index"
                [src]="image"
                [alt]="getWorkflowStepAltText()"
                class="carousel-image"
                [class.fit-cover]="currentFits[i] === 'cover'"
                loading="lazy"
              />
            </div>

            <div class="carousel-nav">
              <button
                type="button"
                class="nav-btn nav-prev"
                (click)="previousImage(); $event.stopPropagation()"
                [attr.aria-label]="getAriaLabel('previousImage')"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18 9 12l6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <button
                type="button"
                class="nav-btn nav-next"
                (click)="nextImage(); $event.stopPropagation()"
                [attr.aria-label]="getAriaLabel('nextImage')"
              >
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="carousel-dots">
          <button
            type="button"
            *ngFor="let image of currentImages; let i = index"
            class="dot"
            [class.active]="isActive(i)"
            (click)="selectImage(i)"
          ></button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for Fullscreen View -->
  <div class="image-modal" [class.show]="isModalOpen" (click)="closeModal()">
    <button type="button" class="modal-close" (click)="closeModal()" [attr.aria-label]="getAriaLabel('closeModal')">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>

    <div class="modal-content" (click)="$event.stopPropagation()">
      <button type="button" class="modal-nav modal-prev" (click)="previousImage()" [attr.aria-label]="getAriaLabel('previousImage')">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18 9 12l6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <img [src]="modalImageSrc" [alt]="getAltText('modalImage')" class="modal-image" />

      <button type="button" class="modal-nav modal-next" (click)="nextImage()" [attr.aria-label]="getAriaLabel('nextImage')">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m9 6 6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</section>
